import React from 'react';

import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';

import './index.less';
import './index.en.less';
import './index.mobile.en.less';
import Section0 from './section0';
import Section1 from './section1';
import Section2 from './section2';
import Section3 from './section3';

interface ITopic1000Props {
  settings: any;
}

const Topic1000: React.FunctionComponent<ITopic1000Props> = ({ settings }) => (
  <TopicContainer className="t1000">
    <TopicItem id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item t1000_2" id="2">
      <Section1 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item t1000_3" id="3">
      <Section2 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item t1000_4" id="4">
      <Section3 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default Topic1000;
